import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

// `minHeight`: tela cheia por padrão; dentro do layout (menu e barra já na tela)
// use uma altura menor para não criar rolagem à toa.
const LoadingScreen = ({ message = 'Carregando...', minHeight = '100vh' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight,
        backgroundColor: 'background.default',
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{ mb: 2 }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mt: 2 }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
